import {Command} from "commander";

export function createProgram(): Command {
	return new Command();
}
